import { useMemo } from 'react';
import clsx from 'clsx';
import type { FormElement, FormValues } from './types';
import { Typography } from '@ywwwtseng/react-kit';

export interface FormElementInfoProps {
  values: FormValues;
  calculated?: FormValues;
  isSubmitting: boolean;
  element: FormElement;
  description?: React.ReactNode;
  errors: Record<string, string | boolean>;
}

export function FormElementInfo({
  values,
  calculated = {},
  isSubmitting,
  element,
  description,
  errors,
}: FormElementInfoProps) {
  const validateType =
    'validateType' in element ? element.validateType : 'onSubmit';

  const error = useMemo(() => {
    if ('name' in element) {
      if (
        isSubmitting ||
        (validateType === 'onChange' &&
          (values[element.name] || calculated[element.name]))
      ) {
        return errors[element.name];
      }
    }

    return null;
  }, [validateType, isSubmitting, element, errors, values, calculated]);

  const text = useMemo(() => {
    if (error && validateType !== 'onChange') {
      return null;
    }

    if (description) {
      return description;
    }

    return null;
  }, [validateType, error, description]);

  return (
    <div className="flex gap-1 px-1">
      {error && (
        <div className={clsx({ 'max-w-[50%]': text })}>
          <Typography
            size="1"
            // 換行
            className="text-destructive"
          >
            {error}
          </Typography>
        </div>
      )}
      {typeof text === 'string' ? (
        <Typography
          size="1"
          className={clsx('text-placeholder', {
            'ml-auto': validateType === 'onChange',
          })}
        >
          {text}
        </Typography>
      ) : (
        text
      )}
    </div>
  );
}
